// localStorage-backed favorite tools list. Stars on tool cards toggle into here
// and CreatorHome surfaces them at the top of the home screen.

const STORAGE_KEY = "workshop_favorite_tools_v1";

function safeRead(): string[] {
  try {
    if (typeof window === "undefined") return [];
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((h): h is string => typeof h === "string") : [];
  } catch {
    return [];
  }
}

function safeWrite(list: string[]): void {
  try {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    // Notify same-tab listeners (storage event only fires across tabs).
    window.dispatchEvent(new CustomEvent("workshop-favorites-changed"));
  } catch {
    // private mode etc.
  }
}

export function getFavoriteTools(): string[] {
  return safeRead();
}

export function isFavoriteTool(href: string): boolean {
  return safeRead().includes(href);
}

/** Toggle favorite state. Returns the new state (true = now favorited). */
export function toggleFavoriteTool(href: string): boolean {
  if (!href) return false;
  const current = safeRead();
  if (current.includes(href)) {
    safeWrite(current.filter((h) => h !== href));
    return false;
  }
  safeWrite([href, ...current]);
  return true;
}
